// Generated by CoffeeScript 2.7.0
var ChipInput;

import DebounceInput from 'trunks/vue/admin/components/libs/debounce_input.js';

import ResizeMixin from 'trunks/vue/admin/mixins/resize.js';

export default ChipInput = Vue.extend({
  components: {
    DebounceInput: DebounceInput
  },
  mixins: [ResizeMixin],
  props: {
    // 单行还是多行?
    wrapable: {
      type: Boolean,
      default: true
    },
    chips: {
      type: Array,
      default: function() {
        return [];
      }
    },
    postfix: {
      type: String,
      default: '组织'
    },
    idKey: {
      type: String,
      default: 'id'
    },
    nameKey: {
      type: String,
      default: 'name'
    },
    counterText: {
      type: [String, Number]
    },
    readonly: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data: function() {
    return {
      overflowed: false
    };
  },
  template: `<div class="chip-input-container justify-box" :class='{ "multiple-line": wrapable }'>
  <template v-if='wrapable'>
    <span class="chip"
          v-for='chip in chips'
          :key='chip[idKey]'>
      <span class='text-ellipsis'>{{ chip[nameKey] }}</span>
      <i class="slp-times" v-if='!readonly' @click.stop='removeChip(chip)'></i>
    </span>
  </template>
  <div class="chip-list-container" v-if='!wrapable && !overflowed'>
    <span class="chip"
          v-for='chip in chips'
          :key='chip[idKey]'>
      <span class='text-ellipsis'>{{ chip[nameKey] }}</span>
      <i class="slp-times" v-if='!readonly' @click.stop='removeChip(chip)'></i>
    </span>
  </div>
  <div class="chip-list-container" v-if='!wrapable && overflowed && chips.length'>
    <span class="chip">
      <span class='text-ellipsis'>{{ chips[0][nameKey] }}</span>
      <i class="slp-times" v-if='!readonly' @click.stop='removeChip(chips[0])'></i>
    </span>
    <span class="placeholder">{{ counterLabel }}</span>
  </div>
  <div class="content debounce-input-container" ref='overflowJudge'>
    <DebounceInput :placeholder='placeholder'
                   :readonly='readonly'
                   @change='keywordChange' ref='input' />
  </div>
</div>`,
  computed: {
    counterLabel: function() {
      return `等${this.counterText || this.chips.length}个${this.postfix}...`;
    }
  },
  methods: {
    keywordChange: function(value) {
      return this.$emit('keywordChange', value);
    },
    removeChip: function(chip) {
      return this.$emit('chipClicked', chip);
    },
    clear: function() {
      if (this.readonly) {
        return;
      }
      return this.$refs.input.clear();
    }
  }
});
